import { gql } from '@apollo/client'

const GetReadingRoomParticipants = gql`
  subscription GetReadingRoomParticipants($reading_id: uuid!) {
    view_reading_room_participants(
      where: { reading_id: { _eq: $reading_id } }
    ) {
      reading_id
      user_id
      person_name
      participationstate
      created
      reading {
        readingevents {
          readingstate {
            name
            created
          }
        }
      }
    }
  }
`

export default GetReadingRoomParticipants
